class SearchModal extends HTMLElement {
  constructor() {
    super();
    this.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close()
    );
    this.querySelector(".modal__close-button").addEventListener(
      "click",
      this.close.bind(this)
    );
    this.querySelector(".offcanvas-overlay").addEventListener(
      "click",
      this.close.bind(this)
    );
    const searchForm = this.querySelector('form.search');
    if (searchForm) searchForm.addEventListener('submit', (event) => {
      const query = searchForm.querySelector('input[name="q"]')?.value.trim();
      if (!query) { event.preventDefault(); return; }
      // Submit reliably even if the predictive results widget is unavailable.
      event.preventDefault();
      event.stopImmediatePropagation();
      const target = new URL(searchForm.action, window.location.href);
      target.searchParams.set('q', query);
      target.searchParams.set('options[prefix]', 'last');
      window.location.assign(target.toString());
    }, true);
    this.setHeaderSearchIconAccessibility();
  }

  setHeaderSearchIconAccessibility() {
    document.querySelectorAll("#header_search__action").forEach((searchIconButton) => {
      searchIconButton.setAttribute("role", "button");
      searchIconButton.setAttribute("aria-haspopup", "dialog");
      searchIconButton.addEventListener("click", (event) => {
        event.preventDefault();
        this.open(searchIconButton);
      });
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    setTimeout(() => {
      this.classList.add("animate", "active");
      this.querySelector('input[name="q"]')?.focus();
    });

    this.addEventListener(
      "transitionend",
      () => {
        const focusElement =
          this.querySelector(".search__content_inner") ||
          this.querySelector(".modal__close-button");
        trapFocus(focusElement, this.querySelector('input[name="q"]') || focusElement);
      },
      { once: true }
    );
    document.body.classList.add("body-overflow-hidden");
  }

  close() {
    this.classList.remove("active");
    document.body.classList.remove("body-overflow-hidden");
    if (typeof removeTrapFocus === 'function') removeTrapFocus(this.activeElement);
  }
  setActiveElement(element) {
    this.activeElement = element;
  }
}
customElements.define("search-modal", SearchModal);
